// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3bFUf","error":"Textarea_error__13fXd","readonly":"Textarea_readonly__3CL5e","disabled":"Textarea_disabled__2iFD7"};